import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import type { ButtonType } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type Props = {
    isOpen: boolean;
    hideTitle?: boolean;
    onCancel?: () => void;
    onConfirm: () => void;
    description?: string;
    confirmButtonType?: ButtonType;
    confirmButtonText?: string;
};

export const DeleteMarketModal = ({
    isOpen,
    hideTitle = false,
    onCancel,
    onConfirm,
    description,
    confirmButtonType = "warning",
    confirmButtonText,
}: Props) => {
    const { translate } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            shouldCloseOnEsc={!!onCancel}
            shouldCloseOnOverlayClick={!!onCancel}
            customStyles={{
                content: {
                    width: "400px",
                },
            }}
        >
            {hideTitle ? null : (
                <Modal.Header>
                    <Modal.Title>{translate("rankTracker.gsc.deleteModal.title")}</Modal.Title>
                </Modal.Header>
            )}

            <Modal.Content>
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                    padding="16px 0 8px"
                >
                    {description ?? translate("rankTracker.gsc.deleteModal.description")}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                {onCancel ? (
                    <Button
                        type="flat"
                        onClick={onCancel}
                    >
                        {translate("global.cancel")}
                    </Button>
                ) : null}
                <Button
                    type={confirmButtonType}
                    onClick={onConfirm}
                >
                    {confirmButtonText || translate("global.delete")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
